<template>
  <div class="main-page second py-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 left">
          <div class="profile_info">
            <div class="seller-card">
              <div>
                <div
                  class="user-online-indicator is-online"
                  data-user-id="1152855"
                >
                  <i class="fa fa-circle"></i>online
                </div>
              </div>
              <div><a href="#" class="ambassadors-badge">Beneficiary</a></div>
              <div class="user-profile-info">
                <div>
                  <div class="user-profile-image">
                    <label class="user-pict">
                      <img
                        src="@/assets/images/profile.png"
                        class="img-fluid user-pict-img"
                        alt="Askbootstrap" />
                      <a
                        href="#"
                        class="user-badge-round user-badge-round-med locale-en-us top-rated-seller"
                      ></a
                    ></label>
                  </div>
                </div>
                <div class="user-profile-label">
                  <div class="username-line">
                    <a href="#" class="seller-link">Gloria Amaka</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="seller-profile">
            <ul class="list-group">
              <li class="list-group-item active">Introduction</li>
              <li class="list-group-item">Lesson 1 - Problems, data, and tools; Visualization; Matlab</li>
              <li class="list-group-item">Lesson 2 - Linear regression; SSE; gradient descent; closed form; normal equations; features</li>
              <li class="list-group-item">Lesson 3 - Classification problems; decision boundaries; nearest neighbor methods</li>
              <li class="list-group-item">Lesson 4 - Linear classifiers</li>

            </ul>
          </div>
          <a href="certification" class="btn small_primary_button_dark"
            >Certification Complete - View Certificate</a
          >
        </div>
        <div class="col-lg-8 right">
          <div class="recommended">
            <div class="row">
              <div class="col-md-4">
                <div class="plyr__video-embed" id="player">
      
  <iframe
    src="https://www.youtube.com/embed/-2AcCEZaCZM?origin=https://plyr.io&amp;iv_load_policy=3&amp;modestbranding=1&amp;playsinline=1&amp;showinfo=0&amp;rel=0&amp;enablejsapi=1"
    allowfullscreen
    width="800"
                    height="600"
    allowtransparency
    allow="autoplay"
  ></iframe>
</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
